import IndexSidebar from 'flarum/forum/components/IndexSidebar';

/**
 * Opens the composer for a new discussion through core's own action (which also lets
 * flarum/tags preselect the current section), or shows the log-in modal for guests.
 */
export function startDiscussion() {
  return IndexSidebar.prototype.newDiscussionAction.call(IndexSidebar.prototype).catch(() => {});
}
flarum.reg.add('tarotportal-theme', 'forum/utils/actions', { startDiscussion: startDiscussion, });